import { jsx as o } from "react/jsx-runtime";
import { ModificationDenyTooltip as r } from "./components/ModificationDenyTooltip.js";
import { useFeatureFlag as e } from "../../../common/providers/FeatureFlagsProvider/hooks/useFeatureFlag.js";
const i = ({ allowed: i2 = true, tooltip: t, children: m }) => e("featureWorkingPeriodsModifyCheck") ? i2 ? m : o(r, { tooltip: t, children: m }) : m;
export {
  i as IsModificationAllowed
};
//# sourceMappingURL=IsModificationAllowed.js.map
